import graphqlClient from "../../api/axios_interceptor";
import { FetchPreferencesMutation, SetDefaultPreferencesMutation, UpdatePreferencesMutation } from "../../api/graphql/queries/preferences";
import { FETCH_PREFERENCES, SET_DEFAULT_PREFERENCES, UPDATE_PREFERENCES } from "../actions/actionTypes";
import { updateActionErrors } from "./updateErrors";

const preferencesMiddleware = storeAPI => next => async action => {
    let preferencesInfo = action.payload;

    switch (action.type) {
        case FETCH_PREFERENCES:
            // TODO: API call to send a single sms
            try {
                await graphqlClient({
                    data: {
                        query: FetchPreferencesMutation()
                    }
                }).then((queryResult) => {
                    if (queryResult.data.errors) {
                        action = updateActionErrors(action, queryResult.data.errors);
                    } else {
                        let preferences = queryResult.data.data.preferences;
                        action = ({
                            ...action,
                            payload: {
                                ...action.payload,
                                preferences
                            }
                        });

                    }

                });
            } catch (error) {
                console.error(error);
                action = updateActionErrors(action, error)
            }
            break;

        case SET_DEFAULT_PREFERENCES:
            try {
                await graphqlClient({
                    data: {
                        query: SetDefaultPreferencesMutation()
                    }
                }).then((queryResult) => {
                    if (queryResult.data.errors) {
                        action = updateActionErrors(action, queryResult.data.errors);
                    } else {
                        if (queryResult.data.data.setDefaultPreferences.success) {
                            let preferences = queryResult.data.data.setDefaultPreferences.preferences;
                            action = ({
                                ...action,
                                payload: {
                                    ...action.payload,
                                    preferences
                                }
                            });
                        }
                    }

                });
            } catch (error) {
                console.error(error);
                action = updateActionErrors(action, error)
            }
            break;
        case UPDATE_PREFERENCES:
            try {
                await graphqlClient({
                    data: {
                        query: UpdatePreferencesMutation(preferencesInfo.paymentAlerts, preferencesInfo.reports)
                    }
                }).then((queryResult) => {
                    if (queryResult.data.errors) {
                        action = updateActionErrors(action, queryResult.data.errors);
                    } else {
                        let preferences = queryResult.data.data.updatePreferences.preferences;
                        action = ({
                            ...action,
                            payload: {
                                ...action.payload,
                                preferences
                            }
                        });

                    }

                });
            } catch (error) {
                console.error(error);
                action = updateActionErrors(action, error)
            }
            break;

    }
    return next(action);
};


export {
    preferencesMiddleware
}